import parse from 'html-react-parser';
import dompurify from 'dompurify';

export const parseComment = (comment) => {
    const commentWithEscapedBadBreakLines = comment ? comment.replace(/<br\/>/g, '\n') : '';
    const sanitizedHtmlString = dompurify.sanitize(`<div>${commentWithEscapedBadBreakLines}</div>`, { KEEP_CONTENT: true, WHOLE_DOCUMENT: true });
    return parse(sanitizedHtmlString);
  };